import { tryCatch } from "@/lib/try-catch";
import { Ok, Err } from "ts-results";
import { Response } from "./types";
import { z } from "zod";

export const putPresignedUrlRequest = z.object({
    file: z.instanceof(File),
    url: z.string().min(1),
});

export type PutPresignedUrlRequest = z.infer<typeof putPresignedUrlRequest>;

export async function putPresignedUrl(
  request: PutPresignedUrlRequest
): Promise<Response<number>> {
  const responseResult = await tryCatch(
    fetch(request.url, {
      method: "PUT",
      body: request.file,
      headers: {
        "Content-Type": request.file.type,
      },
    })
  );

  if (responseResult.err) {
    return Err({
      message: `Error al consultar el servidor: ${responseResult.val.message}`,
      devMessage: responseResult.val.message,
    });
  }

  const response = responseResult.val;

  if (!response.ok) {
    const errMessageResult = await tryCatch(response.json());
    return errMessageResult.err
      ? Err({
          message: `Error al unir los archivos: ${errMessageResult.val.message}`,
          devMessage: errMessageResult.val.message,
        })
      : Err(errMessageResult.val);
  }

  return Ok(response.status);
}
